import { useContext, useState } from "react";
import { useFormik } from "formik";
import { RiEyeCloseLine } from "react-icons/ri";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import "./index.css";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { LoginInitialValues } from "#validations/initialValues.js";
import { validationSchema } from "#validations/validationSchema.js";
import { AlertTost, CustomInput } from "#components";
import usePost from "#hooks/usePost.js";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import { AuthContext } from "#contexts/authContext.jsx";

import ImagesUrl from "#constants/images.js";
import toast from "react-hot-toast";

const Login = (props) => {
  const [show, setShow] = useState(false);
  const { login } = useContext(AuthContext);

  const navigate = useNavigate();

  const {
    mutateAsync: loginMutateAsync,
    isLoading: isLoadingLogin,
    error: errorLogin,
  } = usePost(ENDPOINTS.ADMIN_LOGIN, QUERY_KEYS.LOGIN_QUERY_KEY);

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    initialValues: LoginInitialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const data = {
        email: values.email,
        password: values.password,
      };
      try {
        const response = await loginMutateAsync(data);
        if (response.status === true) {
          AlertTost(response?.message, "success");
          login(response?.data?.token);
          resetForm();
        }
      } catch (error) {
        toast.dismiss();
        AlertTost(error?.response?.data?.message, "error");
      }
    },
  });

  const handleClick = () => setShow(!show);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <div className="login-main">
      <div className="login-logo-main">
        <img src={ImagesUrl.loginBackground} alt="" />
      </div>
      <div
        className="login-form-main"
        data-aos="fade-right"
        data-aos-duration="1500"
      >
        <div className="login-card-item">
          <div className="inner-content">
            {/* <h1 className="text-uppercase">{userRole}</h1> */}
            <div className="text-center">
              <h1 className="">Log In</h1>
              <p>Welcome back ! Please enter your login details</p>
            </div>

            <div className="form-main">
              <div className="form-inner-div">
                <CustomInput
                  label="Email"
                  type="text"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Email Address"
                  error={errors.email}
                  touched={touched.email}
                />
              </div>
              <div className="form-inner-div">
                <CustomInput
                  label="Password"
                  type={show ? "text" : "password"}
                  placeholder="Password"
                  name="password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.password}
                  touched={touched.password}
                  onKeyPress={handleKeyPress}
                />

                <div onClick={handleClick} className="password-eye">
                  {show ? <RiEyeCloseLine /> : <MdOutlineRemoveRedEye />}
                </div>
              </div>
              {/* <div className="forgot-main">
                <p onClick={() => navigate("/forgot-password")}>
                  Forgot Password ?
                </p>
              </div> */}
            </div>
            <button
              type="button"
              disabled={isLoadingLogin}
              onClick={() => handleSubmit()}
            >
              {isLoadingLogin ? (
                <ClipLoader size={17} color="#fff" />
              ) : (
                "Log In"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
